import React, { useState } from "react";
import Layout from "../layout/Layout";
import Banner from "../components/directdials/Banner";
import Terms from "../components/directdials/DirectDials";
const DirectDials = () => {
  return (
    <>
      <Layout>
        <Banner />
        <Terms />
      </Layout>
    </>
  );
};

export default DirectDials;
